import React from 'react';
// No agent form here per requirements — show a standard overview card

export default function NegotiationBot() {
  return (
    <div className="page">
      <header className="header"><h1>Negotiation Chatbot</h1></header>
      <main className="container">
        <div className="panel">
          <h2 style={{marginTop:0}}>Coming Soon</h2>
          <p>
            A guided negotiation chatbot for Maskan that can discuss price bands,
            MOQs, tiers and discounts over chat. It integrates with your CRM and
            supports handoff to human reps on thresholds.
          </p>
          <ul>
            <li>Price‑band awareness and counter‑offers</li>
            <li>Lead capture and CRM logging</li>
            <li>Supervisor escalation rules</li>
          </ul>
        </div>
      </main>
    </div>
  );
}
